@file:kotlin.js.JsExport
package com.narbase.letsgo.dto.core

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2023/02/17.
 */

class MultiLingualTextDto(val en: String, val ar: String, val fr: String)